<template>
  <div class="w_100per h_100per">
    <AlertModalV2 v-if="isSuccessModal" @confirm-btn="onConfirmBtn">
      <template #alertmodal-nontitle>저장 되었습니다.</template>
    </AlertModalV2>
    <PageSlot>
      <template #pageslot-contents>
        <div class="max960-container autoplay-container">
          <div class="autoplay-header">
            <h1 class="global_page_title">자동 재생 설정</h1>
            <a tabindex="0" class="common-close-lg cursor" @click="onClickBack">
              <img class="common-close-lg" src="/media/images/icon/close-lg-icon.png" alt="close-lg-icon.png" />
            </a>
          </div>
          <!-- 자동재생 on / off-->
          <div class="autoplay-onoffbox">
            <span class="autoplay-text">자동 재생 기능</span>

            <ToggleBox :tooglevalue="autoplay.useAt === 'Y' ? true : false" @click-toogle="onClickToogle" />
          </div>
          <!-- 요일 -->
          <div class="daylist-box" :class="autoplay.useAt !== 'Y' ? 'disabled' : ''">
            <label class="form-label">
              요일
            </label>
            <ul class="day-list">
              <li>
                <DayChipComponent v-bind="getDayActive('mon')" @click-chip="onClickChipDay('mon')">
                  <template #chipname>월</template>
                </DayChipComponent>
              </li>
              <li>
                <DayChipComponent v-bind="getDayActive('tue')" @click-chip="onClickChipDay('tue')">
                  <template #chipname>화</template>
                </DayChipComponent>
              </li>
              <li>
                <DayChipComponent v-bind="getDayActive('wed')" @click-chip="onClickChipDay('wed')">
                  <template #chipname>수</template>
                </DayChipComponent>
              </li>
              <li>
                <DayChipComponent v-bind="getDayActive('thu')" @click-chip="onClickChipDay('thu')">
                  <template #chipname>목</template>
                </DayChipComponent>
              </li>
              <li>
                <DayChipComponent v-bind="getDayActive('fri')" @click-chip="onClickChipDay('fri')">
                  <template #chipname>금</template>
                </DayChipComponent>
              </li>
              <li>
                <DayChipComponent v-bind="getDayActive('sat')" @click-chip="onClickChipDay('sat')">
                  <template #chipname>토</template>
                </DayChipComponent>
              </li>
              <li>
                <DayChipComponent v-bind="getDayActive('sun')" @click-chip="onClickChipDay('sun')">
                  <template #chipname>일</template>
                </DayChipComponent>
              </li>
            </ul>
          </div>
          <!-- 시간 -->
          <div class="selecttime-box" :class="autoplay.useAt !== 'Y' ? 'disabled' : ''">
            <label class="form-label">
              시간
            </label>
            <div class="selecttime-list">
              <CommonSelectTIme
                :isdisabled="autoplay.useAt !== 'Y'"
                :value="autoplay.startTime"
                @change-value="onChangeValue"
              />
              <span class="middle">~</span>
              <CommonSelectTIme
                :isdisabled="autoplay.useAt !== 'Y'"
                :value="autoplay.endTime"
                @change-value="onChangeEndTime"
              />
            </div>
          </div>
          <!-- 완료 버튼 -->
          <div class="btn-box">
            <div class="complete-btn">
              <CompleteButton @click-btn="onClickBtn">
                <template #btnname>완료</template>
              </CompleteButton>
            </div>
          </div>
          <!-- 유의사항 box-->
          <div class="notice-box">
            <span class="notice-text">유의사항</span>

            <div class="notice-list-wrap">
              <NoticeList
                :noticelist="[
                  '설정하신 시간에 플레이어가 자동으로 on/off 됩니다.',
                  `자동 재생은 '이용중'인 스페이스에서만 작동합니다.`,
                  '자동 재생은 자동로그인 상태에서만 작동합니다.'
                ]"
              />
            </div>
          </div>
        </div>
      </template>
    </PageSlot>
  </div>
</template>
<script>
import PageSlot from '@/slot/PageSlot.vue';
import ChipComponent from '@/components/Chip/ChipComponent.vue';
import DayChipComponent from '@/components/Chip/DayChipComponent.vue';
import ToggleBox from '@/components/ToggleBox/ToggleBox.vue';
import CommonSelectTIme from '@/components/common/CommonSelectTIme.vue';
import CompleteButton from '@/components/BasicButton/CompleteButton.vue';
import NoticeList from '@/components/common/NoticeList.vue';
import AlertModalV2 from '@/components/modal/AlertModalV2.vue';
import { getAutoPlayApi, updateAutoPlayApi } from '@/service/api/profileApi';
export default {
  components: {
    PageSlot,
    ToggleBox,
    ChipComponent,
    DayChipComponent,
    CommonSelectTIme,
    CompleteButton,
    NoticeList,
    AlertModalV2
  },
  data() {
    return {
      autoplay: {
        autoPlayId: 'auto_play_003056',
        spaceId: 'space_004364',
        mon: 'Y',
        tue: 'Y',
        wed: 'Y',
        thu: 'Y',
        fri: 'Y',
        sat: 'Y',
        sun: 'Y',
        useAt: 'N',
        startTime: '09:00',
        endTime: '18:00'
      },
      activeSelect: {
        bg: 'bg-black700',
        ftcolor: 'font-white'
      },
      activeNotSelect: {
        bg: 'bg-black200',
        ftcolor: 'font-black700'
      },
      spaceId: null,
      isSuccessModal: false
    };
  },
  created() {
    this.spaceId = this.$route.params.spaceid;
    this.getAutoPlay();
  },
  methods: {
    onClickBack() {
      this.$router.back();
    },
    onConfirmBtn() {
      this.isSuccessModal = false;
      /* CronTab 세팅  */
      this.$store.dispatch('cronjob/settingCronJob');
      this.$router.push({ name: 'MySpace' });
    },
    onClickChipDay(key) {
      if (this.autoplay.useAt !== 'Y') return;
      if (this.autoplay[key] === 'Y') {
        this.autoplay[key] = 'N';
      } else {
        this.autoplay[key] = 'Y';
      }
    },
    onClickToogle() {
      this.autoplay.useAt = this.autoplay.useAt === 'Y' ? 'N' : 'Y';
    },
    async updateAutoPlay() {
      try {
        const { data } = await updateAutoPlayApi(this.autoplay);
        const { resultCd } = data;
        if (resultCd === '0000') {
          this.isSuccessModal = true;
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAutoPlay() {
      try {
        const { data } = await getAutoPlayApi(this.spaceId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          this.autoplay = result;
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onClickBtn() {
      this.$gatag.event('web_auto_play_setting_page_save_button'); // 자동재생 저장 버튼

      this.updateAutoPlay();
    },
    onChangeValue(val) {
      // 값을 받아서 값 세팅 필요
      this.autoplay.startTime = val;
    },
    onChangeEndTime(val) {
      // 값을 받아서 값 세팅 필요
      this.autoplay.endTime = val;
    },
    getDayActive(key) {
      if (this.autoplay[key] === 'Y') {
        return this.activeSelect;
      }
      return this.activeNotSelect;
    }
  },
  computed: {
    isDisabeld() {
      return this.autoplay.useAt !== 'Y';
    },
    monActive() {
      if (this.autoplay.mon === 'Y') {
        return this.activeSelect;
      }
      return this.activeNotSelect;
    }
  },
  beforeDestroy() {
    this.$gatag.event('web_auto_play_setting_page_back_button'); // 자동재생 설정페이지 뒤로가기
  }
};
</script>
<style scoped src="@/assets/css/autoplayv2/autoplayv2.css"></style>
